export default __webpack_public_path__ + "static/media/6C2_at_2020-14-2.2d8b187c.png";